import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom'; 
import Cookies from 'js-cookie';
import axios from 'axios';
import { Container, Col, Carousel, Row, Button, Figure, Form,  } from 'react-bootstrap';   
import './Home.css'; 
import DatePicker, { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import imgBox1 from './img/dedos.webp';
import imgBox2 from './img/Sun.webp';
import imgBox3 from './img/telefono.webp';
import { Spinner } from 'react-bootstrap';
import check from './img/Check.png';
import rectangle from './img/Rectangle 1.webp';
import rectangleMobile from './img/Rectangle-mobile.webp';
import iceCream from './img/helado.webp'; 
import quote from './img/Icon.png';
import avatar from './img/Avatar1.webp';
import avatar2 from './img/Avatar2.webp';
import image from './img/Avatar.png'; 
import avatar3 from './img/Avatar3.webp';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import LazyHydrate from "react-lazy-hydration";

registerLocale("es", es);

class Home extends Component {
    
    constructor () {
        super();
        let url  = window.location.href;
        let lang;
        if(url.search('/en') !== -1){
            lang='en';
        }else{
            lang='es';
        }
        var listaPalabras = JSON.stringify(require('../../translate/'+lang+'.json'));
        var wordList = JSON.parse(listaPalabras);
        if(lang === "es"){
            lang='';
        }else{
            lang=lang+'/';
        }
        this.state = {
            lang: lang,
            classSlider : "slidecontainer rangeNoActive",
            wordList: wordList.home,
            wordListUrl: wordList.url,
            bottom : -436,
            birthday : "",
            date : "",
            debts : "0",
            monthGrossPremium : 0, 
            next : "hide-next",
            totalBalance : 0,
            data : [],
            spinner : "hide",
            price : "show"
        };
        this.onDebts=this.onDebts.bind(this)
        this.handleCapital=this.handleCapital.bind(this)
        this.handleDateChange=this.handleDateChange.bind(this)
        this.handleGoData = this.handleGoData.bind(this)
    }

    handleGoData() {
        if(this.state.next==="") {
            Cookies.set('dataUserSpecial', JSON.stringify(this.state.data), { expires: 1, path: '/'  });
            this.props.history.push('/' + this.state.lang+""+this.state.wordListUrl.recommender5); 
        }
    }



    handleCapital() {
        var totalBalance = document.getElementById('total-balance').value;
        this.setState({ 
            totalBalance: totalBalance
        }); 
        if(totalBalance!=="" && this.state.birthday!=="") {
            if(this.state.debts==="0") {
                var mortgage=false;
            } else {
                var mortgage=true;
            }
            
            var birthday=this.state.date;  
            var object={
                "quick_data": {
                  "mortgage": mortgage,
                  "birthday": birthday,
                  "coverage": parseInt(totalBalance)
                }
            } 

            
            this.setState({ 
                spinner : "show",
                price : "hide"
            }); 
            // Calcular prima mensual
            axios.post(process.env.REACT_APP_API_URL + '/users/quickQuotation', object,
            {
            headers: {
                'Content-Type': 'application/json'
            }
            }).then(res => { 
                var resData = res.data;    
                var data=this.state.data; 
                data.product_information=resData.premium_result
                data.quick_data=object.quick_data; 

                
                this.setState({ 
                    spinner : "hide",
                    price : "show",
                    next: ""
                }); 

                
                
                if(resData.status==="ok") { 
                        var data=this.state.data; 
                        data.product_information=resData.premium_result
                        data.quick_data=object.quick_data; 
                        if(resData.status==="ok") {
                            var monthGrossPremium=resData.premium_result.premiums.premium[0].yearly_gross_premium/12;
                            this.setState({ 
                                monthGrossPremium: parseFloat(monthGrossPremium).toFixed(2),
                                data : data
                            }); 
                        }                
                } else { 
                        Cookies.set('dataUser', JSON.stringify(this.state.data), { expires: 1, path: '/'  });
                        Cookies.set('dataUserSpecial', JSON.stringify(this.state.data), { expires: 1, path: '/'  });
                        this.props.history.push('/' + this.state.lang+""+this.state.wordListUrl.recommenderIntro); 
                }
            }).catch(error => {
                //console.log(error)
                if (!error.response) { 
                    //console.log(error.response)
                } else {
                    //console.log(error.response)
                }  
            }); 



        } else {            
            this.setState({ 
                next:  "hide-next"
            }); 
        }
    }

    handleDateChange(date) { 
        
        if(date===null) {
            var format="";
        } else {
            date = new Date(date);
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            format="yyyy-MM-dd"
            format = format.replace("MM", month.toString().padStart(2,"0"));   
            if (format.indexOf("yyyy") > -1) {
                format = format.replace("yyyy", year.toString());
            } else if (format.indexOf("yy") > -1) {
                format = format.replace("yy", year.toString().substr(2,2));
            } 
            format = format.replace("dd", day.toString().padStart(2,"0")); 
        }
        this.setState({ 
            birthday: date,
            date : format
        }); 
        
        if(this.state.totalBalance!=="" && format!=="") {

            if(this.state.debts==="0") {
                var mortgage=false;
            } else {
                var mortgage=true;
            }
            
            var birthday=format;  
            var object={
                "quick_data": {
                  "mortgage": mortgage,
                  "birthday": birthday,
                  "coverage": parseInt(this.state.totalBalance)
                }
            } 

            
            this.setState({ 
                spinner : "show",
                price : "hide"
            }); 
            // Calcular prima mensual
            axios.post(process.env.REACT_APP_API_URL + '/users/quickQuotation', object,
            {
            headers: {
                'Content-Type': 'application/json'
            }
            }).then(res => {  
                this.setState({ 
                    spinner : "hide",
                    price : "show"
                }); 
                var resData = res.data;    
                if(resData.status==="ok") { 
                        var data=this.state.data; 
                        data.product_information=resData.premium_result
                        data.quick_data=object.quick_data; 
                        if(resData.status==="ok") {
                            var monthGrossPremium=resData.premium_result.premiums.premium[0].yearly_gross_premium/12;
                            this.setState({ 
                                monthGrossPremium: parseFloat(monthGrossPremium).toFixed(2),
                                data : data
                            }); 
                        }                
                } else { 
                        Cookies.set('dataUser', JSON.stringify(this.state.data), { expires: 1, path: '/'  });
                        Cookies.set('dataUserSpecial', JSON.stringify(this.state.data), { expires: 1, path: '/'  });
                        this.props.history.push('/' + this.state.lang+""+this.state.wordListUrl.recommenderIntro); 
                }
            }).catch(error => {
                //console.log(error)
                if (!error.response) { 
                    //console.log(error.response)
                } else {
                    //console.log(error.response)
                }  
            }); 


            this.setState({ 
                next: ""
            }); 


        } else {            
            this.setState({ 
                next:  "hide-next"
            }); 
        }
    }
    
    onDebts (e) {  
        var debts=this.state.debts;
        if(debts===0) {
            debts=1;
            var classSlider="slidecontainer rangeActive";  
        } else {
            debts=0;
            classSlider="slidecontainer rangeNoActive";  
        }

        if(this.state.totalBalance!=="" && this.state.birthday!=="") {
            if(debts==="0") {
                var mortgage=false;
            } else {
                var mortgage=true;
            }
            
            var birthday=this.state.date;  
            var object={
                "quick_data": {
                  "mortgage": mortgage,
                  "birthday": birthday,
                  "coverage": parseInt(this.state.totalBalance)
                }
            } 
            // Calcular prima mensual
            axios.post(process.env.REACT_APP_API_URL + '/users/quickQuotation', object,
            {
            headers: {
                'Content-Type': 'application/json'
            }
            }).then(res => {  
                var resData = res.data;    
                var data=this.state.data; 
                data.product_information=resData.premium_result
                data.quick_data=object.quick_data; 
                if(resData.status==="ok") {

                    var monthGrossPremium=resData.premium_result.premiums.premium[0].yearly_gross_premium/12;
                    this.setState({ 
                        monthGrossPremium: parseFloat(monthGrossPremium).toFixed(2),
                        data : data
                    }); 



                }  else {
                    Cookies.set('dataUser', JSON.stringify(this.state.data), { expires: 1, path: '/'  });
                    Cookies.set('dataUserSpecial', JSON.stringify(this.state.data), { expires: 1, path: '/'  });
                    this.props.history.push('/' + this.state.lang+""+this.state.wordListUrl.recommenderIntro); 
                }
            }).catch(error => { 
                //console.log(error)
                if (!error.response) { 
                    //console.log(error.response)
                } else {
                    //console.log(error.response)
                }  
            }); 


            this.setState({ 
                next: ""
            }); 

        } else {            
            this.setState({ 
                next:  "hide-next"
            }); 
        }
         
        this.setState({ 
            debts: debts,            
            classSlider : classSlider 
        });  
    }

    componentDidMount () {  
        document.querySelector('meta[name="description"]').setAttribute("content", this.state.wordList.descripcion);
        document.title = this.state.wordList.titulo; 

         window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        var data={
            "product_information": {
              "coverage": 0,
              "minimal_coverage": 0,
              "premiums": {}
            },
            "quick_data": {},
            "contact_data": {
              "id": "0",
              "firstname": "",
              "email": "",
              "mobile_phone": ""
            }
          };
          
        this.setState({ 
            data: data
        });  
        var bottom=this.state.bottom;

        window.onscroll = function() { 
            if(window.innerWidth<1000) {
                bottom=-250
                if(bottom+(window.scrollY/2)<0) {
                    this.setState({  
                        bottom : bottom+parseInt(window.scrollY/2)
                    });   
                }
            } else {
                if(bottom+(window.scrollY/2)<0) {
                    this.setState({  
                        bottom : bottom+parseInt(window.scrollY/2)
                    });   
                }

            }
          }.bind(this); 
          var txt="Fácil";
          var i=0;
          function typewrite() { 
            if (i < txt.length) {
                if(document.getElementById("texto")) {
                    document.getElementById("texto").innerHTML += txt.charAt(i);
                    i++;
                    setTimeout(typewrite, 100);
                } else {
                    clearInterval(setIntervalText);
                }
            }
          }
          typewrite();
          const array = ["Fácil", "Simple", "Claro", "Diferente", "Asequible", "Honesto", "Sin papeles", "Digital", "100% Online", "Rápido", "Para ti", "Ágil", "Responsable"]
          var number=1;
          var setIntervalText =setInterval(function () { 
            if(number>12) { number=0; }
            if(document.getElementById("texto")) {
                document.getElementById("texto").innerHTML = ""; 
                txt=array[number];
                i=0;
                typewrite();
                number++; 
            } else {
                clearInterval(setIntervalText);
            }
          }.bind(this), 2000);


        // SI SE SALE DEL FORMULARIO A ESTA PÁGINA, BORRAMOS COOKIES
        Cookies.remove('dataUser')
        Cookies.remove('dataInsuranceProfile')
        Cookies.remove('dataInsuranceProfileSelect')
        Cookies.remove('dataUserMedical')
        Cookies.remove('dataUserSpecial')
        Cookies.remove('basicProfile') 
        setTimeout(function(){  
        if(window.location.hash==="#calculator-form") { 
            var element = document.getElementById('calculator-form'); 
            window.scrollTo({
                top: element.offsetTop+1200,
                left: 0,
                behavior: 'smooth'
            });  
        } }, 500);
    }
 

    render() { 
        const { wordList, wordListUrl, lang, bottom, birthday, debts, classSlider, monthGrossPremium, next, price, spinner } = this.state;
        return ( 
            <div id="home">
            <Header type={"dark"}/>
            <div className="home-livetopic  background-box-1" id="home-box-1">
            <Container className="contenido">
                 <Row className="home-box-1 text-center">
                     <Col sm={12}  className="text-sun-home">
                         <h1 class="title-left">{wordList.tituloInicial}  <br/><span class='purple' id="texto"> </span></h1>
                         {/* <Link to={"/"+lang+""+wordListUrl.recommender1} id="insure-button-display"><Button size="lg" className="box-button  margin-top-45">{wordList.asegurar}  </Button></Link>
                         <p class="title-right"> 
                             <ul>
                             <li class="span-right" dangerouslySetInnerHTML={{__html: wordList.textoIntro }}></li>
                             <li class="span-right" dangerouslySetInnerHTML={{__html: wordList.textoIntro2 }}></li>
                             <li class="span-right" dangerouslySetInnerHTML={{__html: wordList.textoIntro3 }}></li>
                             </ul>
                          </p> 
                          <div class="float-left"  style={{width:"100%"}}>
                            <Link to={"/"+lang+""+wordListUrl.recommender1} id="insure-button"><Button size="lg" className="box-button  margin-top-45">{wordList.asegurar}  </Button></Link> */}
                          <a href="https://www.iatisegurosvida.com/" target="_blank" rel="noopener noreferrer" id="insure-button-display"><Button size="lg" className="box-button  margin-top-45">{wordList.asegurar}  </Button></a>
                          <p class="title-right">
                             <ul>
                             <li class="span-right" dangerouslySetInnerHTML={{__html: wordList.textoIntro }}></li>
                             <li class="span-right" dangerouslySetInnerHTML={{__html: wordList.textoIntro2 }}></li>
                             <li class="span-right" dangerouslySetInnerHTML={{__html: wordList.textoIntro3 }}></li>
                             </ul>
                          </p> 
                          <div class="float-left"  style={{width:"100%"}}>
                            <a href="https://www.iatisegurosvida.com/" target="_blank" rel="noopener noreferrer" id="insure-button"><Button size="lg" className="box-button  margin-top-45">{wordList.asegurar}  </Button></a>
                            
                            
                            <a href="#home-box-2"><Button size="lg"  id="know-button" className="border-button margin-left-15 margin-top-45">{wordList.saber}  </Button></a>
                        </div>
                     </Col>
                     <Col xs={{ span: 12, offset: 0 }} className="images-sun-home">
                        <img src={imgBox2} className="img-sun" id="img-sun" style={{bottom:bottom}}/>
                        <img src={imgBox1} className="img-hands-sun"/>
                     </Col>
                 </Row>
            </Container>  
            </div>
            <LazyHydrate whenVisible> {
            <div className="home-livetopic background-box-2" id="home-box-2">
            <Container className="contenido discover">
                 <Row className="home-box-2 text-center" style={{position:"relative"}}>
                     <LazyLoadImage src={imgBox3} className="hand-mobile"/>
                     <Col md={12} lg={{ span: 6, offset: 3 }} style={{paddingLeft:"30px", paddingRight:"30px"}}>
                         <h2>{wordList.descubre} <span id="letter-1">L</span><span id="letter-2">i</span><span id="letter-3">v</span><span id="letter-4">e</span><span id="letter-5">t</span><span id="letter-6">o</span><span id="letter-7">p</span><span id="letter-8">i</span><span id="letter-9">c</span></h2>
                     </Col>
                     <Col md={12} id="person-carrousel">
                        <Carousel>
                            <Carousel.Item className="text-center">   
                                <div className="box-home"> 
                                    <Row>
                                        <Col xs={4}> 
                                            <LazyLoadImage src={avatar} alt="avatar"/>   
                                        </Col>
                                        <Col xs={8}>
                                            <p>{wordList.edad}: {wordList.edad1}</p>
                                            <p>{wordList.hijos}: {wordList.hijos1} </p>
                                            <p>{wordList.deudas}: {wordList.deudas1} </p>
                                        </Col> 
                                    </Row> 
                                    <h3>{wordList.seguroVida}</h3>
                                    <p className="text-card">{wordList.capital}: 250.000 €</p>
                                    <p className="text-card-min" dangerouslySetInnerHTML={{__html: wordList.seguroVidaTexto }}></p>
                                    <hr/>
                                    <Link to={"/"+lang+""+wordListUrl.recommender1}> {wordList.calcular}  </Link>                
                                </div>      
                            </Carousel.Item>
                            <Carousel.Item className="text-center">    
                                <div className="box-home-2"> 
                                    <Row>
                                        <Col xs={4}> 
                                            <LazyLoadImage src={avatar2} alt="avatar"/>   
                                        </Col>
                                        <Col xs={8}>
                                            <p>{wordList.edad}: {wordList.edad2}</p>
                                            <p>{wordList.hijos}: {wordList.hijos2} </p>
                                            <p>{wordList.deudas}: {wordList.deudas2} </p>
                                        </Col> 
                                    </Row> 
                                    <h3>{wordList.necesidad}</h3>
                                    <p className="text-card">{wordList.capital}: 60.000 €</p>
                                    <p className="text-card-min" dangerouslySetInnerHTML={{__html: wordList.necesidadTexto }}></p> 
                                    <hr/>
                                    <Link to={"/"+lang+""+wordListUrl.recommender1}> {wordList.calcular}  </Link>   
                                </div>     
                            </Carousel.Item>
                            <Carousel.Item className="text-center">    
                                <div className="box-home-3">  
                                    <Row>
                                        <Col xs={4}> 
                                            <LazyLoadImage src={avatar3} alt="avatar"/>   
                                        </Col>
                                        <Col xs={8}>
                                            <p>{wordList.edad}: {wordList.edad3}</p>
                                            <p>{wordList.hijos}: {wordList.hijos3} </p>
                                            <p>{wordList.deudas}: {wordList.deudas3} </p>
                                        </Col> 
                                    </Row> 
                                    <h3>{wordList.unico}</h3>
                                    <p className="text-card">{wordList.capital}: 200.000 €</p>
                                    <p className="text-card-min" dangerouslySetInnerHTML={{__html: wordList.unicoTexto }}></p>  
                                    <hr/>
                                    <Link to={"/"+lang+""+wordListUrl.recommender1}> {wordList.calcular}  </Link>   
                                </div>  
                            </Carousel.Item> 
                        </Carousel>
                    </Col>
                     <Col md={12}  lg={4}  className="person-carrousel">
                         <div className="box-home"> 
                            <Row>
                                <Col xs={4}> 
                                    <LazyLoadImage src={avatar} alt="avatar"/>   
                                </Col>
                                <Col xs={8}>
                                    <p>{wordList.edad}: {wordList.edad1}</p>
                                    <p>{wordList.hijos}: {wordList.hijos1} </p>
                                    <p>{wordList.deudas}: {wordList.deudas1} </p>
                                </Col> 
                            </Row> 
                            <h3>{wordList.seguroVida}</h3>
                            <p className="text-card">{wordList.capital}: 250.000 €</p>
                            <p className="text-card-min" dangerouslySetInnerHTML={{__html: wordList.seguroVidaTexto }}></p>
                            <hr/>
                            <Link to={"/"+lang+""+wordListUrl.recommender1}> {wordList.calcular}  </Link>                
                         </div>                          
                     </Col>
                     <Col md={12}  lg={4} className="person-carrousel">
                         <div className="box-home-2"> 
                            <Row>
                                <Col xs={4}> 
                                    <LazyLoadImage src={avatar2} alt="avatar"/>   
                                </Col>
                                <Col xs={8}>
                                    <p>{wordList.edad}: {wordList.edad2}</p>
                                    <p>{wordList.hijos}: {wordList.hijos2} </p>
                                    <p>{wordList.deudas}: {wordList.deudas2} </p>
                                </Col> 
                            </Row> 
                            <h3>{wordList.necesidad}</h3>
                            <p className="text-card">{wordList.capital}: 60.000 €</p>
                            <p className="text-card-min" dangerouslySetInnerHTML={{__html: wordList.necesidadTexto }}></p> 
                            <hr/>
                            <Link to={"/"+lang+""+wordListUrl.recommender1}> {wordList.calcular}  </Link>   
                         </div>     
                     </Col>
                     <Col md={12}  lg={4} className="person-carrousel">
                         <div className="box-home-3">  
                            <Row>
                                <Col xs={4}> 
                                    <LazyLoadImage src={avatar3} alt="avatar"/>   
                                </Col>
                                <Col xs={8}>
                                    <p>{wordList.edad}: {wordList.edad3}</p>
                                    <p>{wordList.hijos}: {wordList.hijos3} </p>
                                    <p>{wordList.deudas}: {wordList.deudas3} </p>
                                </Col> 
                            </Row> 
                            <h3>{wordList.unico}</h3>
                            <p className="text-card">{wordList.capital}: 200.000 €</p>
                            <p className="text-card-min" dangerouslySetInnerHTML={{__html: wordList.unicoTexto }}></p>  
                            <hr/>
                            <Link to={"/"+lang+""+wordListUrl.recommender1}> {wordList.calcular}  </Link>   
                         </div>    
                     </Col>
                     <Col md={12} className="new-form" id="calculator-form">
                            <h3>{wordList.cuanto}</h3>
                            <h4>{wordList.cuantoSubtitle}</h4> 
 
                    <div id="container-white">
                        <div id="top-container">
                        <Row>
                            <Col xs={2} style={{textAlign:"center", paddingRight:"0"}}>
                                <Figure>
                                    <Figure.Image
                                        width={80}
                                        height={80}
                                        alt="180x180"
                                        className="image"
                                        src={image}
                                    /> 
                                </Figure>
                            </Col>                    
                            <Col xs={10}>
                                <h2>{wordList.intro} </h2>
                                
                                <p>{wordList.intro2}</p> 
                            </Col>
                        </Row>
                        </div>
                        <div id="bottom-container">
                            <Form> 
                                <Row> 
                                    <Col  md={12} lg={5}> 
                                        <span className="left range-label">{wordList.debts}</span>
                                        <div className={classSlider}>
                                            <div className="backgroundToggle"  onClick={(e) => this.onDebts(e)}></div>
                                            <input type="range" min="0" max="1" className="slider" value={debts}  /> 
                                        </div>  
                                        <br/>
                                        <br/>
                                        <Form.Group className="center-label" style={{maxWidth: "300px",  margin: "0 auto", marginTop:"20px"}}>
                                            <Form.Label>{wordList.fecha}</Form.Label>
                                            <DatePicker 
                                                locale="es"
                                                className="form-control" 
                                                selected={birthday} 
                                                dateFormat='dd/MM/yyyy'
                                                onChange={(date) => this.handleDateChange(date)}
                                                placeholderText={wordList.placeholderDate}
                                                showMonthDropdown
                                                showYearDropdown 
                                            /> 
                                        </Form.Group>
                                        <Form.Group className="center-label" style={{maxWidth: "300px",  margin: "0 auto", marginTop:"20px", position:"relative"}}>
                                            <Form.Label>{wordList.capitalAsegurar} </Form.Label>
                                            <Form.Control type="number"  placeholder="10000" id="total-balance"  onBlur={ this.handleCapital}/>
                                            <Form.Text className="input-text-place">
                                            {wordList.euros}
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                    
                                    <Col md={12} lg={7}>  
                                        <Col  md={12} className="budget" >
                                            <h4 className="title-recomendation">{wordList.seguro }:</h4>
                                            
                                            <Spinner className={spinner} style={{margin: "10px auto"}}animation="border"/>
                                            <p className={"prize-calcule "+price}>{wordList.desde}  <span>{new Intl.NumberFormat("de-DE").format(monthGrossPremium)} {wordList.mes}</span>   </p>
                                            <p className="prize-impuestos">{wordList.caso} <br/> {wordList.impuestos}   </p>
                                         
                                             
                                            {/*<div style={{textAlign:"center"}}>
                                                <Button size="lg"   onClick={this.handleGoData} className={next +" bottom-call"}>{wordList.botonContratar} </Button>
                                            </div> */}
                                            <div style={{textAlign:"center"}}>
                                                <a href="https://www.iatisegurosvida.com/" target="_blank" rel="noopener noreferrer">
                                                    <Button size="lg" className={next +" bottom-call"}>{wordList.botonContratar} </Button>
                                                </a>
                                            </div>

                                        </Col>
                                    </Col>
                                </Row>
                            </Form> 
                        </div>
                    </div> 


                     </Col>
                     <Col md={12}  lg={{ span: 6, offset: 3 }} style={{paddingLeft:"30px",paddingTop:"60px", paddingRight:"30px"}}>
                         <h2>{wordList.como}</h2> 
                     </Col>
                     <Col md={12}  lg={{ span: 6, offset: 3 }} className="box-mobile">
                         <div className="box-work-2">
                             <h3><LazyLoadImage src={check}/>{wordList.tuSituacion}</h3>
                            <p>{wordList.tuSituacionTexto}</p>                         
                         </div>                          
                     </Col>
                     <Col md={12}  lg={{ span: 6, offset: 3 }} className="box-mobile">
                         <div className="box-work-3">
                             <h3><LazyLoadImage src={check}/>{wordList.recomendaciones}</h3>
                            <p>{wordList.recomendacionesTexto}</p>   
                         </div>     
                     </Col>
                     <Col md={12}  lg={{ span: 6, offset: 3 }} className="box-mobile" style={{ marginBottom:"110px"}}>
                         <div className="box-work">
                             <h3><LazyLoadImage src={check}/>{wordList.decision}</h3>
                            <p>{wordList.decisionTexto}</p>   
                         </div>    
                     </Col>
                 </Row>
            </Container> 
            </div>
            }</LazyHydrate> 
            
            <LazyHydrate whenVisible> {
            <div className="home-livetopic background-box-3" id="home-box-3" style={{position:"relative"}}>
                <LazyLoadImage src={rectangle} className="rectangle"/>
                <LazyLoadImage src={iceCream} className="ice-cream"/>
                <LazyLoadImage src={quote} className="quote"/>
                <LazyLoadImage src={rectangleMobile} className="rectangle-mobile"/>

                <Container className="contenido">
                    <Row className="home-box-3"> 
                        <Col md={12}  lg={{ span: 8, offset: 2 }} className="carrousel-home">
                        <Carousel>
                            <Carousel.Item className="text-center">   
                                <h4>{wordList.titular1}</h4> 
                                <LazyLoadImage src={avatar3} className="person"/>
                                <p>{wordList.nombre1}</p>
                                <p>{wordList.ciudad1}</p> 
                            </Carousel.Item>
                            <Carousel.Item className="text-center">    
                                <h4>{wordList.titular2}</h4> 
                                <LazyLoadImage src={avatar2} className="person"/>
                                <p>{wordList.nombre2}</p>
                                <p>{wordList.ciudad2}</p> 
                            </Carousel.Item>
                            <Carousel.Item className="text-center">    
                                <h4>{wordList.titular3}</h4> 
                                <LazyLoadImage src={avatar} className="person"/>
                                <p>{wordList.nombre3}</p>
                                <p>{wordList.ciudad3}</p> 
                            </Carousel.Item> 
                        </Carousel>
                        </Col>
                        <Col md={12}  lg={{ span: 6, offset: 1 }} className="message-ice-cream">
                            <h3>{wordList.tacha}</h3> 
                                <Link to={"/"+lang+""+wordListUrl.howWork}><Button size="lg" className="border-button">{wordList.saber}  </Button></Link>
                                {/*<Link to={"/"+lang+""+wordListUrl.recommender1}><Button size="lg" className="box-button margin-left-15">{wordList.reservar}  </Button></Link> */}
                                <a href="https://www.iatisegurosvida.com/" target="_blank" rel="noopener noreferrer"><Button size="lg" className="box-button margin-left-15">{wordList.reservar}  </Button></a>
                        </Col>
                    </Row>
                </Container>
            </div> 
            }</LazyHydrate> 
            <LazyHydrate whenVisible> {
            <Footer  type={"light"}/>
            }</LazyHydrate> 
            
            </div>
        );
    }
}

export default withRouter((Home));
